import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { TitleBar, NavigationBar } from "@bbnpm/bb-ui-framework";
import { useAuth } from "../../utility/auth.js";
import { StyledHeader, StyledNavigationBar } from "./index.styles";
import { ServerConfig } from "../../interfaces/server-config";
import { getServerConfig } from "../../api/config";

const BrandTag: React.FC = (props) => <a {...props} href="/" />;

export const Header: React.FC = () => {
  const { user, signin, signout } = useAuth();
  const [config, setConfig] = useState<ServerConfig | null>(null);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const serverConfig: ServerConfig = await getServerConfig();
        setConfig(serverConfig);
      } catch (err) {
        console.error(err);
      }
    };
    fetchConfig();
  }, []);

  const navigate = useNavigate();
  const location = useLocation(),
    urlPath = location.pathname;
  return (
    <StyledHeader>
      <TitleBar
        productName="Multimedia Upload Anywhere"
        brandRenderer={BrandTag}
        width="1180px"
        skipToId="main"
      >
        <TitleBar.Links>
          <TitleBar.IconLink
            iconName={"user"}
            menuItems={
              user
                ? [
                    {
                      label: `${user.firstName} ${user.lastName}`,
                      readonly: true,
                    },
                    TitleBar.IconLinkDivider,
                    {
                      label: "Logout",
                      renderer: "a",
                      onClick: signout,
                    },
                  ]
                : [
                    {
                      label: "Login",
                      renderer: "a",
                      onClick: signin,
                    },
                  ]
            }
          />
        </TitleBar.Links>
      </TitleBar>
      <StyledNavigationBar width="1180px">
        <NavigationBar.Links>
          <NavigationBar.Link
            active={urlPath.startsWith("/upload_asset/default")}
            onClick={() => navigate("/upload_asset/default")}
          >
            Upload Media Asset
          </NavigationBar.Link>
          {config?.enableAssetGalleryView && (
            <NavigationBar.Link
              active={urlPath.startsWith("/gallery")}
              onClick={() => navigate("/gallery")}
            >
              Gallery View
            </NavigationBar.Link>
          )}
        </NavigationBar.Links>
      </StyledNavigationBar>
    </StyledHeader>
  );
};
